import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NzModalModule, NzModalService } from 'ng-zorro-antd/modal';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { KorviuButtonComponent } from '../../../../shared/components/korviu-button/korviu-button.component';

@Component({
  selector: 'app-okeey-cash-congratulations-modal',
  standalone: true,
  imports: [TranslateModule, NzModalModule, NzButtonModule, KorviuButtonComponent],
  templateUrl: './okeey-cash-congratulations-modal.component.html',
  styleUrl: './okeey-cash-congratulations-modal.component.scss'
})
export class OkeeyCashCongratulationsModalComponent {
  constructor(
    private _router: Router,
    private modal: NzModalService
  ) {}

  public goToProfile() {
    this._router.navigate(['workspace', 'profile']);
    this.modal.closeAll();
  }

  public goToDashboard() {
    this._router.navigate(['workspace', 'dashboard']);
    this.modal.closeAll();
  }
}
